import styled from 'styled-components';

const Title = styled.h4``;

export default Title;
